import { render } from "./FieldLabel.vue?vue&type=template&id=092bf410"
import script from "./FieldLabel.vue?vue&type=script&lang=js"
export * from "./FieldLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__